import config from './load-config';

export const contactNumberPrefix = `+${config.formatting.phoneNumbers.countryCode}`;
const countryCode = config.formatting.phoneNumbers.countryCode;

/**
 * Following example from: https://codesandbox.io/s/10rzowm323
 * Changed the length checks and returns to be less jittery.
 *
 * @param value
 */
export const maskContactNumber = value => {
  if (!value) return value;
  const onlyNums = value.replace(/[^\d]/g, '');
  if (onlyNums.length === 0) return '';
  if (onlyNums.length <= 3) return `(${onlyNums.slice(0, 3)}`;
  if (onlyNums.length <= 6)
    return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}`;
  return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(
    6,
    10
  )}`;
};

/**
 * Returns a formatted phone number without country code
 * using format: '(0##) ###-####'
 *
 * @param value
 */
export const displayPhoneNumber = value => {
  if (!value) return value;
  const onlyNumsAndPlus = value.replace(/[^\d\+]/g, '');

  if (onlyNumsAndPlus.startsWith(contactNumberPrefix)) {
    return maskContactNumber(
      `0${onlyNumsAndPlus.slice(contactNumberPrefix.length)}`
    );
  }
  if (onlyNumsAndPlus.startsWith(countryCode)) {
    return maskContactNumber(`0${onlyNumsAndPlus.slice(countryCode.length)}`);
  }
  if (onlyNumsAndPlus.startsWith('0')) {
    return maskContactNumber(onlyNumsAndPlus);
  }
  return maskContactNumber(`0${onlyNumsAndPlus}`);
};

/**
 * Returns a formatted phone number starting with the country code
 * using format: '+## ## ### ####'
 *
 * @param value
 */
export const displayPhoneNumberWithCountryCode = value => {
  if (!value) return value;
  let phoneNr = value;
  if (value.startsWith(contactNumberPrefix)) {
    phoneNr = value.slice(contactNumberPrefix.length);
  }
  if (value.startsWith(countryCode)) {
    phoneNr = value.slice(countryCode.length);
  }
  if (value.startsWith('0')) {
    phoneNr = value.slice(1);
  }

  return `${contactNumberPrefix} ${phoneNr.slice(0, 2)} ${phoneNr.slice(
    2,
    5
  )} ${phoneNr.slice(5)}`;
};

/**
 * Should be used before sending a contactNumber to the BE.
 * Wanted to use this on the form field, but removing the zero breaks the mask.
 *
 * @param value
 */
export const formatPhoneNumber = (value?: string) => {
  if (!value) return value;
  let onlyNums = value.replace(/[^\d]/g, '');

  if (onlyNums.slice(0, 1) === '0') onlyNums = onlyNums.slice(1);

  if (!onlyNums.startsWith(countryCode)) {
    if (onlyNums.length > 9) onlyNums = onlyNums.slice(0, 9);
    return `${contactNumberPrefix}${onlyNums}`;
  }
  return onlyNums;
};
